module.exports = "<div class=\"container-fluid\">\n  <router-outlet></router-outlet>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// D:/PROJECTS/ANGULAR2_PROJECT/WEB/raspab/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main